var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload_box"},[_c('el-upload',{staticClass:"upload_up",attrs:{"action":"","http-request":_vm.uploadFile,"multiple":"","show-file-list":false}},[_c('el-button',{staticClass:"iconfont upload_btn iconfont iconshangchuan1",attrs:{"size":"small","type":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }